import React, { useEffect, useState } from 'react';
import './ResultGriana.scss';
import { Loading } from '@bvt-features/account/component';
import { GRIDPRO_STYLE } from '@bvt-features/mapana/griana/constant/GRIDPRO_STYLE';
import { InputSelectOption } from '@bvt-shared/component/InputSelectOption';

const generateStyle = (value) => {
  return {
    minWidth: '1rem',
    minHeight: '1rem',
    backgroundColor: GRIDPRO_STYLE.find((ctx) => ctx.gridStatus === value)
      .style.unselected.fillColor,
    opacity: '0.7',
  };
};

const DataPreview = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <div className='ResultGriana DataPreview'>
      <div className='ResultGriana DataPreview--header'>Data preview</div>
      <div className='ResultGriana DataPreview--wrapper'>
        {props.isLoading ? (
          <span style={{ height: '2rem' }} />
        ) : (
          <>
            <InputSelectOption
              allowClear={false}
              data={props.dataPreview.selectOption.data.map((ctx) => {
                return {
                  value: ctx.value,
                  label: (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                      }}
                    >
                      <div style={generateStyle(ctx.acceptable)} />{' '}
                      <span>{ctx.label}</span>
                    </div>
                  ),
                };
              })}
              onChange={props.dataPreview.selectOption.onChange}
              onDropdownVisibleChange={(e) => {
                setOpen(e);
              }}
              open={open}
              value={props.dataPreview.selectOption.value}
            />
          </>
        )}
      </div>
    </div>
  );};

/**
 * @param {object} props
 * @param {JSX.Element | HTMLElement} props.children
 * @param {func} props.onBack
 * @param {func} props.showDashboard
 * @param {object} props.dataPreview
 * @param {object} props.dataPreview.selectOption
 * @param {Array<{label: string, value: string, acceptable: string}>} props.dataPreview.selectOption.data
 * @param {string} props.dataPreview.selectOption.value
 * @param {func} props.dataPreview.selectOption.onChange
 */
export const ResultGriana = (props) => {
  const [removedHeight, setRemovedHeight] = useState(0);

  const getClientHeight = (value) => {
    const docs = document.querySelector(value);
    return docs ? docs.clientHeight : 0;
  };
  const handleHeight = () => {
    const heading = getClientHeight('.PertaminaGrianaContainer--header');
    const header = getClientHeight('.DataPreview');
    const footer = getClientHeight('.grianapertamina--footer');
    setRemovedHeight(heading + header + footer);
  };
  useEffect(() => {
    handleHeight();
    window.addEventListener('resize', handleHeight);
    return () => {
      window.removeEventListener('resize', handleHeight);
    };
  }, []);
  const content = (
    <div
      className='ResultGriana grianapertamina--wrapper'
      style={{ height: `calc(100% - ${removedHeight}px)` }}
    >
      {props?.children}
    </div>
  );

  const loader = (
    <div
      className='ResultGriana grianapertamina--loading-wrapper'
      style={{ height: `calc(100% - ${removedHeight}px)` }}
    >
      <Loading height='2rem' width='2rem' />
    </div>
  );

  return (
    <div className='ResultGriana grianapertamina'>
      <div className='ResultGriana grianapertamina--header'>
        <DataPreview {...props} />
      </div>
      {props.isDetailLoading ? loader : content}
      <div className='ResultGriana grianapertamina--footer'>
        <button
          className='ResultGriana grianapertamina--footer_btn_outline'
          onClick={props?.onBack}
        >
          Back
        </button>
        <div className='ResultGriana grianapertamina--footer_right'>
          <button
            className={`ResultGriana grianapertamina--footer_btn_fill`}
            onClick={props?.showDashboard}
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};
